<script>
export default {
    mounted() {
        if (typeof initPopup === 'function') {
            initPopup();
        }
    }
};
</script>

